<template>
  <div class="alerts">
    <b-alert v-for="alert in alerts"
             :key="alert.id"
             :show="!isDismissed(alert)"
             :variant="getVariant(alert.type)"
             @dismissed="dismiss(alert)"
             dismissible>
      <div v-html="alert.alert"></div>
      <template v-slot:dismiss class="pull-right">
        &nbsp;
      </template>
    </b-alert>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";

  export default {
    name: "Alerts",
    data() {
      return {}
    },
    mounted() {
      this.fetchAlerts();
    },
    methods: {
      ...mapActions([
        'fetchAlerts',
        'dismissAlert'
      ]),
      getVariant(type) {
        switch (parseInt(type)) {
          case 0: return 'success';
          case 1: return 'danger';
          case 2: return 'info';
          case 3: return 'warning';
        }
      },
      isDismissed(alert) {
        return this.dismissedAlerts.indexOf(alert.id) !== -1
      },
      dismiss(alert) {
        this.dismissAlert(alert.id)
      }
    },
    computed: mapState({
      alerts: state => state.alerts.alerts,
      dismissedAlerts: state => state.alerts.dismissedAlerts
    })
  }
</script>

<style scoped>

</style>
